export const createKernelResetCode = () => `
%reset -f
`;
